import React from 'react';
import { Modal, ModalHeader, ModalBody, Button } from 'reactstrap';
import { CgClose } from 'react-icons/cg';
import "./ModalFormularioModulo.css";
import { postGuardarModulo } from "../../../Services/Api";
import { ToastContainer, toast } from 'react-toastify';
import { validarLetrasNumerosEspacios, validarLongitud, validarLongitudMáxima } from '../../../Services/Validaciones';
import { Navigate } from 'react-router-dom';
import InputText from '../../Formularios/InputText';
import InputQuill from '../../Formularios/InputQuill';
import InputHeaders from '../../Formularios/InputHeaders';
import InputComentario from '../../Formularios/InputComentario';
import { modulo } from '../../../Pages/DetallesModulo/Interfaces';

interface props {
  isOpen: boolean,
  closeModal:(accion:number) => void,
  idproyecto:number,
  idsolicitud?:number,
  token:number,
  titulomodal:string,
  accion:number,
  moduloseleccionado?:modulo
}

interface states {
  isOpen: boolean,
  confirmarenvio: boolean,

  txtnombremodulo:string,
  vermsgerrornombre:boolean,
  msgerrornombre:string,

  txtdescripcionmodulo:string,
  vermsgerrordescripcion:boolean,
  msgerrordescripcion:string,

  headerscheckbox:boolean,
  txtheaders:string,
  vermsgerrorheaders:boolean,
  msgerrorheaders:string,

  confirmar:boolean,
  txtcomentario:string,
  txtcomentariolength:number,
  vermsgerrorcomentario:boolean,
  msgerrorcomentario:string,

  redireccionando:boolean
}

export default class ModalFormularioModulo extends React.Component<props,states>{
  constructor(props:props) {
    super(props);
    this.state = {
      isOpen:this.props.isOpen,
      confirmarenvio:false,
      
      txtnombremodulo: (props.accion == 2) ? (props.moduloseleccionado?.nombre_modulo !== undefined ? props.moduloseleccionado.nombre_modulo : ''): '',
      vermsgerrornombre:false,
      msgerrornombre:'',

      txtdescripcionmodulo:(props.accion == 2) ? (props.moduloseleccionado?.descripcion_modulo !== undefined ? props.moduloseleccionado.descripcion_modulo : ''): '',
      vermsgerrordescripcion:false,
      msgerrordescripcion:'',

      headerscheckbox:false,
      txtheaders:(props.accion == 2) ? (props.moduloseleccionado?.headers_modulo !== undefined ? props.moduloseleccionado.headers_modulo : ''): '',
      vermsgerrorheaders:false,
      msgerrorheaders:"",

      confirmar:false,
      txtcomentario:'',
      txtcomentariolength:0,
      vermsgerrorcomentario:false,
      msgerrorcomentario:'',

      redireccionando:false
    }
  }

  async componentDidMount() {
    if (this.props.accion == 2) {
      this.habilitarHeaders(this.state.txtheaders);
    }
  }

  habilitarHeaders=(headers:any)=> {
    if(headers!== null){
      this.setState({headerscheckbox:true})
    }
  }
    
  //Funciones para cambiar el estado de todos los estados.
  nombre = (prop: string) => {
    this.setState({ txtnombremodulo: prop});
  };

  descripcion = (prop: string) => {
    this.setState({ txtdescripcionmodulo: prop});
  };

  headers = (prop: string) => {
    this.setState({ txtheaders: prop});
  };

  habilitar = (prop:boolean) => {
    this.setState({ headerscheckbox: prop});
  }

  comentario = (prop:string) => {
    this.setState({txtcomentario:prop})
  }

  habilitarComentario = (prop:boolean) => {
      this.setState({ confirmar:prop });
  }
  
  showModal=(accion:number)=> {
    this.setState({isOpen:false})
    setTimeout(() => {
      this.props.closeModal(accion);
    }, 200);
  }

  guardarModulo = async () => {
    this.setState({ vermsgerrornombre: false });
    this.setState({ vermsgerrordescripcion: false });
    this.setState({ vermsgerrorheaders: false });
    this.setState({ vermsgerrorcomentario: false});

    let longitudvalidanombre = {longitudminima: 3, longitudmaxima: 45};
    let longitudvalidadescripcion = 3000;
    let longitudvalidaheaders = {longitudminima: 30, longitudmaxima: 500};
    let longitudvalidacomentario = {longitudminima: 8, longitudmaxima: 300};

    let txtnombre = validarLetrasNumerosEspacios(this.state.txtnombremodulo, longitudvalidanombre);
    let txtdescripcion = validarLongitudMáxima(this.state.txtdescripcionmodulo, longitudvalidadescripcion);
    
    //Si headers es null, se asigna una cadena vacía
    let txtheadersnull = this.state.txtheaders || "";
    let txtheaders = validarLongitud(txtheadersnull, longitudvalidaheaders);
    
    let txtcomentario = validarLetrasNumerosEspacios(this.state.txtcomentario, longitudvalidacomentario);
    
    let validacionescorrectas = true;

    if (txtnombre.codigo == "invalid") {
      this.setState({ msgerrornombre: txtnombre.mensaje });
      this.setState({ vermsgerrornombre: true });
      validacionescorrectas = false;
    }
  
    if (txtdescripcion.codigo == "invalid") {
      this.setState({ msgerrordescripcion: txtdescripcion.mensaje });
      this.setState({ vermsgerrordescripcion: true });
      validacionescorrectas = false;
    }
    
    if (txtheaders.codigo == "invalid" && this.state.headerscheckbox==true) {
      this.setState({ msgerrorheaders: txtheaders.mensaje });
      this.setState({ vermsgerrorheaders: true });
      validacionescorrectas = false;
    }

    if (txtcomentario.codigo == "invalid" && this.state.confirmar === true) {
      this.setState({ msgerrorcomentario: txtcomentario.mensaje });
      this.setState({ vermsgerrorcomentario: true });
      validacionescorrectas = false;
    }

    if (validacionescorrectas) {
      let json = {
        "token":this.props.token,
        "id_proyecto":this.props.idproyecto,
        "id_modulo": this.props.accion == 1 ? ("0") : (this.props.moduloseleccionado?.id_modulo !== undefined ? this.props.moduloseleccionado.id_modulo:null),
        "nombre_modulo":this.state.txtnombremodulo,
        "descripcion_modulo":this.state.txtdescripcionmodulo,
        "headers_checkbox":this.state.headerscheckbox,
        "headers_modulo":this.state.txtheaders,
        "id_solicitud":(this.props.idsolicitud !== undefined ? this.props.idsolicitud:null),
        "comentario_checkbox":this.state.confirmar,
        "comentario":this.state.txtcomentario
      }
      const resp = await postGuardarModulo(json);
      
      if (resp.code == 0) {
        const id_modulo = resp.data.id_modulo;
        localStorage.setItem("id_modulo", id_modulo.toString());
        this.showModal(1)
      }else if(resp.code==100){
        this.showModal(2)
        toast.success(resp.message, { autoClose: 1000, position: toast.POSITION.TOP_LEFT })
      }
      else if (resp.code == 200) {
        toast.error(resp.message, { autoClose: 1000, position: toast.POSITION.TOP_LEFT })
        this.showModal(2)
      } 
      else if (resp.code == 250) {
        this.setState({ msgerrornombre: resp.message });
        this.setState({ vermsgerrornombre: true });
      }
      else if (resp.code == 300) {
        toast.warning(resp.message, { autoClose: 1000, position: toast.POSITION.TOP_LEFT })
        this.showModal(2)
      }
      else if (resp.code == 350) {
        toast.info(resp.message, { autoClose: 1000, position: toast.POSITION.TOP_LEFT })
        this.showModal(2)
      }
      else if (resp.code == 400) {
        toast.info(resp.message, { autoClose: 1000, position: toast.POSITION.TOP_LEFT })
        this.showModal(2)
      }
      else if (resp.code == 1000 || resp == -1) {
        toast.error("Error de conexión", { autoClose: 1000, position: toast.POSITION.TOP_LEFT })
        this.showModal(0)
      }
    }
  }
  render() {
    return (
      <>
        {this.state.redireccionando ?
          <>
            {Acciones("detallesmodulo")}
          </>
        :null}
        <ToastContainer />
        <Modal isOpen={this.state.isOpen} size="lg">
          <ModalHeader className="modalHeader">
              <label className='labelTituloModal'> {this.props.titulomodal} </label>
              <CgClose className='iconoCerrarModal' onClick={() => this.showModal(0)}/>
          </ModalHeader>
          <ModalBody>
            <div className="divContenedorModal">
              <div className="row">
                <div className="col">
                  <InputText 
                    label={'Nombre del módulo'} 
                    placeholder='Ej. Login'
                    limitecaracteres={45} 
                    txtvalor={this.state.txtnombremodulo}
                    vermsgerror={this.state.vermsgerrornombre}
                    msgerror={this.state.msgerrornombre}
                    escribir={this.nombre}                  
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                  <InputQuill 
                    label={"Descripcion del módulo"} 
                    isOpcional={true} 
                    isModal={true} 
                    placeholder={"Ingresa la descripción del módulo"} 
                    limitecaracteres={3000} 
                    txtvalor={this.state.txtdescripcionmodulo} 
                    txtvalorlength={0} 
                    vermsgerror={this.state.vermsgerrordescripcion} 
                    msgerror={this.state.msgerrordescripcion} 
                    escribir={this.descripcion}
                  />
                </div>
                <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                  <InputHeaders 
                    isOpcional={true}
                    isModal={true}
                    checkbox={this.state.headerscheckbox}
                    label={"Headers adicionales"}
                    limitecaracteres={500}
                    txtvalor={this.state.txtheaders}
                    vermsgerror={this.state.vermsgerrorheaders}
                    msgerror={this.state.msgerrorheaders}
                    escribir={this.headers} 
                    habilitar={this.habilitar}                      
                  />
                </div>
              </div>
              {this.props.titulomodal === "Nuevo módulo para solicitud" ? 
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <InputComentario 
                      checkbox={this.state.confirmar}
                      label={'Añadir un comentario acerca de la creación del módulo.'}
                      txtvalor={this.state.txtcomentario}
                      vermsgerror={this.state.vermsgerrorcomentario} 
                      msgerror={this.state.msgerrorcomentario}
                      escribir={this.comentario} 
                      habilitar={this.habilitarComentario}
                    />
                  </div>
                </div>
              :null}
            </div>
            <div className="divContenedorBotonesModal">
              <Button className="btnCancelModal" onClick={() => this.showModal(0)}>Cancelar</Button>
              <Button className="btnAceptarModal"onClick={this.guardarModulo}>Guardar</Button>           
            </div>
          </ModalBody>
        </Modal>
      </>
    );
  }
}
function Acciones(bandera:string) {
  if(bandera == 'detallesmodulo'){
    return <Navigate to="/modulo" />;
  }
}